import React from 'react';
import { Link } from 'react-router-dom'; // Add this
import './MakeTheShift.css';

const MakeTheShift = () => {
  return (
    <section className="shift-section">
      <div className="shift-overlay">
        <h3 className="shift-subtitle">Make the shift to</h3>
        <h1 className="shift-title">INNOVATIVE SOLUTIONS</h1>
        <Link to="/contact">
          <button className="shift-btn">
            Contact Us →
          </button>
        </Link>
      </div>
    </section>
  );
};

export default MakeTheShift;
